export default "__VITE_ASSET__835dbb7b__"